<template>
  <brick-game />
</template>

<script>
import BrickGame from "../components/BrickBreakerGame";

export default {
  name: "Brick.container",
  components: {
    BrickGame
  }
};
</script>

<style scoped></style>
